import { render, staticRenderFns } from "./internal_notification.vue?vue&type=template&id=0abbe9b0&scoped=true&"
import script from "./internal_notification.vue?vue&type=script&lang=js&"
export * from "./internal_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abbe9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abbe9b0')) {
      api.createRecord('0abbe9b0', component.options)
    } else {
      api.reload('0abbe9b0', component.options)
    }
    module.hot.accept("./internal_notification.vue?vue&type=template&id=0abbe9b0&scoped=true&", function () {
      api.rerender('0abbe9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/tabs/internal_notification.vue"
export default component.exports